module.exports = __webpack_public_path__ + "static/gradient-image-3cf3a6fb535c33ace1a0ef4087473b92.png";